import React from "react";

function BS4_JS_Modal() {
  return (
    <div>
      <h1>BS4_JS_Modal Component</h1>
      <p>This is the BS4_JS_Modal tutorial page content.</p>
    </div>
  );
}

export default BS4_JS_Modal;
